export default "__VITE_ASSET__qcedKtqu__"